module.exports = __webpack_public_path__ + "img/carousel_2.07ef73e7.jpg";